/*
  Vista rápida propia.

  Se dejó de usar el <quick-add-modal> de Dawn: ese componente lo registra cada
  sección de productos por separado, así que el ojo podía quedar sobre una
  tarjeta cuya página nunca cargó ese archivo, y el clic no abría nada sin dar
  ninguna señal.

  Acá el diálogo se crea una sola vez, se pide la ficha del producto y se
  inyecta su <product-info>. Los componentes de Dawn que vengan dentro se
  activan solos al conectarse al DOM.
*/
(function () {
  const SELECTOR = '.matery-ojo__boton';
  let dialogo = null;
  let ultimoFoco = null;

  function crearDialogo() {
    const el = document.createElement('div');
    el.className = 'matery-vr';
    el.hidden = true;
    el.innerHTML = `
      <div class="matery-vr__fondo" data-cerrar></div>
      <div class="matery-vr__caja" role="dialog" aria-modal="true" aria-label="Vista rápida" tabindex="-1">
        <button type="button" class="matery-vr__cerrar" data-cerrar aria-label="Cerrar">&times;</button>
        <div class="matery-vr__cuerpo" data-cuerpo></div>
      </div>`;

    el.addEventListener('click', (e) => {
      if (e.target.hasAttribute('data-cerrar')) cerrar();
    });

    document.body.appendChild(el);
    return el;
  }

  function abrir(url, disparador) {
    ultimoFoco = disparador;

    /*
      Se comprueba que el diálogo siga en el documento, no solo que exista la
      referencia. Shopify re-renderiza secciones completas al editar o al
      actualizar el carrito, y eso puede llevarse el elemento: con la referencia
      apuntando a un nodo desconectado, el botón quedaba mudo sin dar ningún
      error visible.
    */
    if (!dialogo || !dialogo.isConnected) dialogo = crearDialogo();

    const cuerpo = dialogo.querySelector('[data-cuerpo]');
    cuerpo.innerHTML = '<div class="matery-vr__cargando">Cargando…</div>';
    dialogo.hidden = false;
    document.body.classList.add('overflow-hidden');
    dialogo.querySelector('.matery-vr__caja').focus();

    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        // product-info trae galería, precio, variantes y formulario de compra.
        const ficha = doc.querySelector('product-info') || doc.querySelector('.product');
        if (!ficha) {
          window.location.href = url;
          return;
        }
        cuerpo.innerHTML = '';
        cuerpo.appendChild(ficha);

        // Los botones de pago rápido necesitan reinicializarse al inyectarse.
        if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
      })
      .catch(() => {
        // Antes que dejar un diálogo vacío, se abre la ficha completa.
        window.location.href = url;
      });
  }

  function cerrar() {
    if (!dialogo || dialogo.hidden) return;
    dialogo.hidden = true;
    dialogo.querySelector('[data-cuerpo]').innerHTML = '';
    document.body.classList.remove('overflow-hidden');
    if (ultimoFoco) ultimoFoco.focus();
  }

  document.addEventListener('click', (e) => {
    const boton = e.target.closest(SELECTOR);
    if (!boton) return;
    e.preventDefault();
    e.stopPropagation();
    const url = boton.getAttribute('data-product-url');
    if (url) abrir(url, boton);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') cerrar();
  });
})();
